import { Injectable, OnDestroy, OnInit } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { DatabaseProvider } from '../database/database';
import { AuthProvider } from '../auth/auth';
import { Rx } from 'models/rx';


@Injectable()
export class OrderProvider implements OnInit, OnDestroy {
  private ngUnsubscribe: Subject<any> = new Subject();

  private prescriptionsBatchCountSubject: Subject<number>;
  private _prescriptionsBatchCount: Observable<number>;

  private prescriptionsBatchSubject: Subject<Rx[]>;
  private _prescriptionsBatch: Observable<Rx[]>;

  private orders = [];

  clinic_id: any;
  email: any;

  constructor(
    private auth: AuthProvider,
     private database: DatabaseProvider
     ) {
    this.prescriptionsBatchCountSubject = new Subject();
    this._prescriptionsBatchCount = this.prescriptionsBatchCountSubject.asObservable();

    this.prescriptionsBatchSubject = new Subject();
    this._prescriptionsBatch = this.prescriptionsBatchSubject.asObservable();

    console.log('Order Provider')
    this.updateBadge();
  }

  get listSize(){
    return this._prescriptionsBatchCount;
  }

  get getPrescriptionsBatch(){
    return this._prescriptionsBatch;
  }

  ngOnInit()  {}
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  updateBadge(){
    console.log('Update Badge')
    this.auth.user
    .takeUntil(this.ngUnsubscribe)
    .subscribe(user => {
      if (user) {
      this.email = user.email;
      this.clinic_id = user.clinic_id;
      this.database.getPrescriptionBatchByClinicAndUser(this.clinic_id, this.email)
      .valueChanges()
      .takeUntil(this.ngUnsubscribe)
      .subscribe(rx => {
        console.log('Orders From O P', rx)
        if(rx) {
          this.prescriptionsBatchCountSubject.next(rx.length);
          this.prescriptionsBatchSubject.next(rx);
        }
        else {
          this.prescriptionsBatchCountSubject.next(null);
          this.prescriptionsBatchSubject.next(null);
        }
      });
    } else {
      this.prescriptionsBatchCountSubject.next(null);
      this.prescriptionsBatchSubject.next(null);
    }
  });

          
  }
}



// WEBPACK FOOTER //
// ./src/providers/order/order.ts